var map = {
	"./noble01/昵称变色@2x.png": "e2f9",
	"./noble02/昵称变色@2x.png": "f2f9",
	"./noble03/昵称变色@2x.png": "2614",
	"./noble04/昵称变色@2x.png": "acac",
	"./noble05/昵称变色@2x.png": "e981"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "cfbb";